import { ReactNode } from 'react'

import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '~in-app/components'

interface DialogComponentProps {
  title: string
  description?: string
  onClose?: () => void
  onSubmit?: () => void
  children?: ReactNode
  submitButtonLabel?: string
  submitButtonClass?: string
  closeButtonClass?: string
  isOpen?: boolean // Optional isOpen prop
}

export function DialogComponent({
  title,
  description,
  onClose,
  onSubmit,
  children,
  submitButtonLabel = 'Submit',
  submitButtonClass,
  closeButtonClass,
  isOpen,
}: DialogComponentProps) {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={
        (open) => {
        // If the dialog is closing, call onClose
          if (!open) {
            onClose?.()
          }
        }
      }
    >

      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>

        <div>{children}</div>

        <DialogFooter>

          <DialogClose asChild>
            <Button
              className={`${closeButtonClass} mr-2`}
              color="muted"
              variant="text"
              onClick={onClose} // This will handle closing the dialog
            >
              Cancel
            </Button>
          </DialogClose>

          {
            onSubmit && (
              <Button
                className={submitButtonClass}
                onClick={onSubmit}
              >
                {submitButtonLabel}
              </Button>
            )
          }

        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
